var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288 64C39.52 64 0 182.096 0 273.455C0 379.492 78.799 448 176 448C203.328 448 227.207 441.484 242.107 411.205L262.033 370.709C268.299 358.576 278.1 352.447 288 352.076C297.9 352.447 307.701 358.576 313.967 370.709L333.893 411.205C348.795 441.484 372.674 448 400 448C497.201 448 576 379.492 576 273.455C576 182.096 536.48 64 288 64ZM160 320C124.654 320 96 291.346 96 256S124.654 192 160 192C195.348 192 224 220.654 224 256S195.348 320 160 320ZM416 320C380.654 320 352 291.346 352 256S380.654 192 416 192C451.348 192 480 220.654 480 256S451.348 320 416 320Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.8d6ccb616be7003c0c6cbddaad85cb25.svg";
export { ForwardRef as ReactComponent };